import { StudentNotification } from 'shared/types/notificationTypes'
import styles from "./styles.module.css"
import Pane from 'components/Dashboards/General/Pane'
import { Button } from 'react-bootstrap'
import { updateStudentNotificationStatus } from "shared/routes/notifications/studentNotifications"
import ToolTip from 'components/General/ToolTip'

interface Props {
  notification: StudentNotification
  updateCallback: (notificationId: string) => void
}

const StudentNotificationItem = ({ notification, updateCallback } : Props) => {

  const markAsRead = async () => {
    await updateStudentNotificationStatus(notification.id, "read")
    updateCallback(notification.id)
  }

  const markAsUnread = async () => {
    await updateStudentNotificationStatus(notification.id, "unread")
    updateCallback(notification.id)
  }

  const read = notification.status === "read"

  return (
    <Pane 
      key={notification.id} 
      className={`${styles.fontSize} rounded border border-1 ${read ? `border-info` : `border-dark`} py-2 m-1 d-flex flex-column align-items-start justify-content-start flex-lg-row align-items-lg-center justify-content-lg-between ${styles.notification} ${notification.status === "read" && `bg-light`}`}>
        <div className="text-start">
          <p>
            Your submission for 
            <span className="mx-1 fw-bold mark">{notification.assignment.title}</span>
            has been 
            {notification.type === "submission-graded" ? <span> graded. <i className={`fas fa-check text-success`}/></span> : 
            notification.type === "submission-reject" ? <span> rejected. <i className={`fas fa-x text-danger`}/></span> : 
            notification.type === "submission-rework" ? <span> requested to be reworked. <i className={`fas fa-repeat text-info`}/></span> : ""}
          </p>
          <p className={`mb-2 ${notification.status === "read" ? "text-dark" : "text-muted"}`}>{notification.created}</p>
        </div>
        <div>
          {!read && <ToolTip title="Mark as read"><Button variant="outline-primary" onClick={markAsRead}><i className={`fas fa-envelope fs-5`}/></Button></ToolTip>}
          {read && <ToolTip title="Mark as unread"><Button variant="outline-success" onClick={markAsUnread}><i className={`fas fa-envelope-circle-check fs-5`}/></Button></ToolTip>}
        </div>
    </Pane>
  )
}

export default StudentNotificationItem
